export default __webpack_public_path__ + "static/media/208-germany.6d0be509.svg";